import type { SvgIconProps } from "@mui/material";
import DefaultFileIcon from "../icons/fileFormats/DefaultFileIcon";
import ExcelIcon from "../icons/fileFormats/ExcelIcon";
import ImageFileIcon from "../icons/fileFormats/ImageFileIcon";
import PdfIcon from "../icons/fileFormats/PdfIcon";
import PowerPointIcon from "../icons/fileFormats/PowerPointIcon";
import VideoFileIcon from "../icons/fileFormats/VideoFileIcon";
import WordIcon from "../icons/fileFormats/WordIcon";

interface Props extends SvgIconProps {
  fileExtension: string;
}

const FileIcon = ({ fileExtension, ...props }: Props) => {
  switch (fileExtension) {
    case ".pdf": {
      return <PdfIcon {...props} />;
    }
    case ".docx":
    case ".doc": {
      return <WordIcon {...props} />;
    }
    case ".xls":
    case ".xlsx":
    case ".xlsm":
    case ".csv": {
      return <ExcelIcon {...props} />;
    }
    case ".pptx":
    case ".ppt": {
      return <PowerPointIcon {...props} />;
    }
    case ".png":
    case ".jpg":
    case ".jpeg":
    case ".webp": {
      return <ImageFileIcon {...props} />;
    }
    case ".mp4":
    case ".webm":
    case ".ogv":
    case ".mov": {
      return <VideoFileIcon {...props} />;
    }
    default: {
      return <DefaultFileIcon {...props} />;
    }
  }
};

export default FileIcon;
